<template>
    <div class="addShelf_wrap">
        <div class="shelf_typelist">
            <div class="shelf_tit" v-if="shelfList.length > 0">请选择您想要加入的书架</div>
            <div :class="{shelfbox: true, curChoose: item.pkid == curShelf}" v-for="(item, index) in shelfList" :key="index">
                <span>
                    <h2 class="shelf_name">{{ item.shelfName }}<em v-if="item.pkid == curShelf">当前已选</em></h2>                    
                    <label class="bookshelf_nums"><b>{{ item.bookCount }}</b>本书</label>
                </span>                
                <el-button v-if="item.pkid != curShelf" class="shelf_btn" type="primary" size="small" icon="el-icon-plus" plain @click="addBookToShelf(item.pkid)">加入书架</el-button>
            </div>
            <div class="" style="text-align: center;padding-top: 15px;">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="createShelfTitle">创建书架</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserInfo } from "@/common/utils/localStorage.js";
import { myShelf, addBookshelf, moveToOther } from "@/api/bookshelf";
import popup from "@/common/plugin/dialog/index";
import editorTitle from './editorTitle.vue';

export default {
    props:['ebookid', 'ebooksource', 'type', 'movepkid', 'curshelf'],
    data(){
        return {
            shelfList: [],
            ebookId:'',
            ebookType: '',
            addType: 0,  //选择类型（加入还是移入）
            movePkid:'',
            curShelf:'',
        }
    },
    mounted(){
        let vm = this;
        vm.ebookId = vm.ebookid;
        vm.ebookType = vm.ebooksource;
        if(vm.type == 2) {
            vm.addType = vm.type;
            vm.movePkid = vm.movepkid;
            vm.curShelf = vm.curshelf;
        }
        vm.getShelfList();
    },
    methods:{
        getShelfList() {
            let vm = this;
            myShelf({
                creatorId: getUserInfo().pkid,
                visitType: 1,
                visitUrl: window.location.href,
                visitFunc: '',
            }).then(res => {
                if(res.status){
                    vm.shelfList = res.data;
                }
            }).catch(err => {

            })
        },
        //添加至书架
        addBookToShelf(shelfId){
            let vm = this;
            if(vm.addType == 0){
                addBookshelf({
                    ebookId: vm.ebookId,
                    ebookType: vm.ebookType,
                    creatorId: getUserInfo().pkid,
                    shelfId: shelfId,
                    visitType: 1,
                    visitUrl: window.location.href,
                    visitFunc: '',
                }).then(res => {
                    if(res.status){
                        vm.$emit('ok', res);
                    }
                }).catch(err => {

                });
            }else if(vm.type == 2){ //移入
                moveToOther({
                    ebookId: vm.movePkid,
                    shelfId: shelfId,
                    creatorId: getUserInfo().pkid,
                    visitType: 1,
                    visitUrl: window.location.href,
                    visitFunc: '',
                }).then(res => {
                    if(res.status){
                        vm.$emit('ok', res);
                    }
                }).catch(err => {

                });
            }
        },
        createShelfTitle(){
            let vm = this;
            vm.editor_title = popup('<editor-title :type="type" @close="close" @submit="submit" />',{
                option:{
                    title:'创建书架',
                    width:'450px'
                },
                popup:{
                    data(){
                        return{
                            type: 0
                        }
                    },
                    components:{
                        editorTitle
                    },
                    methods:{
                        submit(res){                  
                            vm.getShelfList();//刷新列表
                            vm.editor_title.hide();
                        },
                        close(){
                            vm.editor_title.hide();
                        }
                    }
                }
            })
            vm.editor_title.show();
        }
    }
}
</script>

<style lang="scss">
.addShelf_wrap{
    padding:20px 10px 0px;
    .shelf_tit{
        padding-bottom: 20px;
        color:#999;
    }
    .shelfbox{
        padding:8px 0px;
        border-bottom: 1px solid #ebeced;
        position: relative;
    }
    h2.shelf_name{
        font-size:14px;
        color:#333;
        font-weight: 700;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-bottom: 5px;
        >em{
            // display: inline-block;
            font-style: normal;
            font-weight: normal;            
            font-size:12px;
            border: 1px solid #ec9819;
            padding: 2px 5px;
            border-radius: 3px;
            line-height: 18px;
            color:#ec9819;
            margin: 0px 10px;
        }
    }
    .bookshelf_nums{
        font-size: 14px;
        color:#999;
        >b{
            padding-right:3px;
            font-weight: normal;
        }
    }
    .shelf_btn{
        position: absolute;
        top:12.5px;
        right:0px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/addShelf/index.vue